import {Injectable} from '@angular/core';
import {DateToolboxComponent} from '../components/date/date-toolbox/date-toolbox.component';
import {
  AbsatzControl, ActionButtonControl,
  BooleanControl,
  ButtonControl,
  DateControl,
  NumberControl,
  RisikosuchfrageControl,
  TextControl,
  UIArtefakt,
  UIContainerControl,
  UiInputControl,
  Wertemenge
} from '../models/uiArtefakt';
import {CheckboxComponent} from '../components/boolean/checkbox/checkbox.component';
import {JaNeinToggleComponent} from '../components/boolean/ja-nein-toggle/ja-nein-toggle.component';
import {DropdownComponent} from '../components/wertemenge/dropdown/dropdown.component';
import {GruppeComponent} from '../components/gruppe/gruppe.component';
import {ButtonToggleComponent} from '../components/wertemenge/button-toggle/button-toggle.component';
import {ErrorService} from '@lv1871/core';
import {RadioGroupComponent} from '../components/wertemenge/radio-group/radio-group.component';
import {UIArtefaktTyp} from '../models/uiArtefaktTyp';
import {TabelleComponent} from '../components/tabelle/tabelle.component';
import {SliderComponent} from '../components/number/slider/slider.component';
import {IntegerComponent} from '../components/number/integer/integer.component';
import {SearchSimpleComponent} from '../components/wertemenge/search-simple/search-simple.component';
import {SearchMultiComponent} from '../components/wertemenge/search-multi/search-multi.component';
import {FliesstextComponent} from '../components/fliesstext/fliesstext.component';
import {AbsatzComponent} from '../components/absatz/absatz.component';
import {LesebestaetigungComponent} from '../components/lesebestaetigung/lesebestaetigung.component';
import {TelefonnummerComponent} from '../components/telefonnummer/telefonnummer.component';
import {DownloadButtonComponent} from '../components/button/download-button/download-button.component';
import {TextfeldComponent} from '../components/text/textfeld/textfeld.component';
import {TextareaComponent} from '../components/text/textarea/textarea.component';
import {IbanComponent} from '../components/text/iban/iban.component';
import {RisikosuchfrageComponent} from '../components/risikosuchfrage/risikosuchfrage.component';
import {DividerComponent} from '../components/divider/divider.component';
import {SymbolComponent} from '../components/symbol/symbol.component';
import {BeitragBoxComponent} from '../components/container/beitrag-box/beitrag-box.component';
import {VotumBoxComponent} from '../components/container/votum-box/votum-box.component';
import {UiSpalteComponent} from '../components/container/ui-spalte/ui-spalte.component';
import {MenuComponent} from '../components/menu/menu.component';
import {SlideToggleComponent} from '../components/boolean/slide-toggle/slide-toggle.component';
import {DoubleComponent} from '../components/number/double/double.component';
import {ListeComponent} from '../components/liste/liste.component';
import {ListenelementComponent} from '../components/liste/listenelement/listenelement.component';
import {MultiselectComponent} from '../components/wertemenge/multiselect/multiselect.component';
import {VermittlernummerComponent} from '../components/text/vermittlernummer/vermittlernummer.component';
import {AdressVorschlagComponent} from '../components/adress-vorschlag/adress-vorschlag.component';
import {DownloadButtonMitVorschauComponent} from '../components/button/download-button-mit-vorschau/download-button-mit-vorschau.component';
import {KundensucheComponent} from '../components/kundensuche/kundensuche.component';
import {NavigationButtonComponent} from '../components/button/navigation-button/navigation-button.component';
import {ModalDialogButtonComponent} from '../components/button/modal-dialog-button/modal-dialog-button.component';
import {VariantenvergleichComponent} from '../components/container/variantenvergleich/variantenvergleich.component';
import {ProcessButtonComponent} from '../components/button/process-button/process-button.component';
import {DateFixedDayComponent} from '../components/date/date-fixed-day/date-fixed-day.component';
import {ProzentComponent} from '../components/number/prozent/prozent.component';
import {InfoButtonComponent} from '../components/button/info-button/info-button.component';
import {RoetelnComponent} from '../components/roeteln/roeteln.component';
import {EmailadresseComponent} from '../components/text/emailadresse/emailadresse.component';
import {GemanagtePortfolioloesungComponent} from '../components/wertemenge/gemanagte-portfolioloesung/gemanagte-portfolioloesung.component';
import {KachelnComponent} from '../components/wertemenge/kacheln/kacheln.component';
import {ZeitraumComponent} from '../components/number/zeitraum/zeitraum.component';
import {AblaufmanagementComponent} from '../components/fonds/ablaufmanagement/ablaufmanagement.component';
import {AnlaufmanagementComponent} from '../components/fonds/anlaufmanagement/anlaufmanagement.component';
import {FondsTableIndividuellesPortfolioComponent} from '../components/fonds/fondstable-individuelles-portfolio/fonds-table-individuelles-portfolio.component';
import {PlatzhalterComponent} from '../components/platzhalter/platzhalter.component';
import {ActionButtonComponent} from '../components/button/action-button/action-button.component';
import {PortfolioUebersichtZuzahlungComponent} from '../components/fonds/portfolio-uebersicht/portfolio-uebersicht-zuzahlung/portfolio-uebersicht-zuzahlung.component';
import {PortfolioUebersichtComponent as PortfolioUebersichtComponent2} from '../components/fonds/portfolio-uebersicht/portfolio-uebersicht/portfolio-uebersicht.component';
import {
  IndividuellePortfolioloesungComponent
} from '../components/wertemenge/individuelle-portfolioloesung/individuelle-portfolioloesung.component';
import {AnlagestrategieComponent} from '../components/wertemenge/anlagestrategie/anlagestrategie.component';
import {
  AblaufManagementUebersichtTableComponent
} from '../components/fonds/portfolio-uebersicht/ablauf-management-uebersicht-table/ablauf-management-uebersicht-table.component';
import {
  AnlaufManagementUebersichtTableComponent
} from '../components/fonds/portfolio-uebersicht/anlauf-management-uebersicht-table/anlauf-management-uebersicht-table.component';
import {
  FondsTableGespeichertesPortfolioComponent
} from '../components/fonds/fondstable-gespeichertes-portfolio/fonds-table-gespeichertes-portfolio.component';
import {ProzentDoubleComponent} from '../components/number/prozent-double/prozent-double.component';
import {
  KachelnZuzahlungAnlagestrategieComponent
} from '../components/wertemenge/kacheln-zuzahlung-anlagestrategie/kacheln-zuzahlung-anlagestrategie.component';

@Injectable()
export class UiArtefaktService {

  constructor(private _errorService: ErrorService) {
  }

  getComponent(artefakt: UIArtefakt): any {
    // Todo: neuer UIArtefakttyp im fisalis
    if (artefakt.FeldnameExtern === '/PortfoliovorlageZuzahlungID' ||
        artefakt.FeldnameExtern === '/PortfoliovorlageID') {
      return FondsTableGespeichertesPortfolioComponent;
    }
    switch (artefakt.UIArtefakttyp) {
      case UIArtefaktTyp.VERMITTLERNUMMER:
        return VermittlernummerComponent;
      case UIArtefaktTyp.FLIESSTEXT:
        this._checkNumberOfNestedArtifacts(artefakt);
        return FliesstextComponent;
      case UIArtefaktTyp.ABSATZ:
        return this._getAbsatzComponent(artefakt as AbsatzControl);
      case UIArtefaktTyp.INTEGER:
        return this._getIntegerComponent(artefakt as NumberControl);
      case UIArtefaktTyp.DOUBLE:
        return DoubleComponent;
      case UIArtefaktTyp.PROZENT:
        return ProzentComponent;
      case UIArtefaktTyp.PROZENT_DOUBLE:
        return ProzentDoubleComponent;
      case UIArtefaktTyp.DATE:
        return this._getDateComponent(artefakt as DateControl);
      case UIArtefaktTyp.BOOLEAN:
      case UIArtefaktTyp.SELECTION_BOOLEAN:
        return this._getBooleanComponent(artefakt as BooleanControl);
      case UIArtefaktTyp.BUTTON:
        return this._getButtonComponent(artefakt as ButtonControl);
      case UIArtefaktTyp.ACTION_BUTTON:
        return this._getButtonComponent(artefakt as ActionButtonControl);
      case UIArtefaktTyp.WERTEMENGE:
        if (artefakt.FeldnameExtern === '/individuellePortfolioloesung' ||
            artefakt.FeldnameExtern === '/individuellePortfolioloesungZuzahlung') {
          return IndividuellePortfolioloesungComponent;
        }
        return this._getWertemengeComponent(artefakt as Wertemenge);
      case UIArtefaktTyp.ARTEFAKT_GRUPPE:
        return GruppeComponent;
      case UIArtefaktTyp.TABELLE:
        return TabelleComponent;
      case UIArtefaktTyp.TELEFONNUMMER:
        return TelefonnummerComponent;
      case UIArtefaktTyp.RISIKOSUCHFRAGE:
        return this._getRisikosuchfragenComponent(artefakt as RisikosuchfrageControl);
      case UIArtefaktTyp.UIVORGANG_REFERENZ:
        return this._getUiVorgangReferenzComponent(artefakt as UiInputControl);
      case UIArtefaktTyp.UI_PLATZHALTER:
        return KundensucheComponent;
      case UIArtefaktTyp.TEXTFELD:
        return this._getTextfeldComponent(artefakt as TextControl);
      case UIArtefaktTyp.BLOCK:
        this._errorService.pushErrorMessage(`Implementierungsfehler: UIBlock ${artefakt.Identifikator} wurde nicht in seine Kindartefakte aufgelöst`);
        return void 0;
      case UIArtefaktTyp.SYMBOL:
        return SymbolComponent;
      case UIArtefaktTyp.UI_CONTAINER:
        return this._getUIContainerComponent(artefakt as UIContainerControl);
      case UIArtefaktTyp.LISTE:
        if (artefakt.FeldnameExtern === '/listePortfolio' ||
            artefakt.FeldnameExtern === '/listePortfolioZuzahlung') {
          return FondsTableIndividuellesPortfolioComponent;
        } else if (artefakt.FeldnameExtern === '/listePortfolioAblaufmanagement') {
          return AblaufmanagementComponent;
        } else if (artefakt.FeldnameExtern === '/listePortfolioAnlaufmanagement') {
          return AnlaufmanagementComponent;
        } else {
          return ListeComponent;
        }
      case UIArtefaktTyp.LISTENELEMENT:
        return ListenelementComponent;
      case UIArtefaktTyp.DIVIDER:
        return DividerComponent;
      case UIArtefaktTyp.ADRESSVORSCHLAG:
        return AdressVorschlagComponent;
      case UIArtefaktTyp.ROETELN:
        return RoetelnComponent;
      case UIArtefaktTyp.WERTEMENGE_KDB_ABFRAGE:
        return DropdownComponent;
      case UIArtefaktTyp.ZEITRAUM:
        return ZeitraumComponent;
      case  UIArtefaktTyp.UEBERSICHT_FONDSANALGE:
        return PortfolioUebersichtComponent2;
      case  UIArtefaktTyp.UEBERSICHT_FONDSANLAGE_ZUZAHLUNG:
        return PortfolioUebersichtZuzahlungComponent;
      //case  UIArtefaktTyp.UEBERSICHT_FONDSANLAGE_OPTIONEN:
      //  return AnlaufAblaufManagementUebersichtComponent;
      case  UIArtefaktTyp.UEBERSICHT_FONDSANLAGE_ABLAUFMANAGEMENT:
        return AblaufManagementUebersichtTableComponent;
      case  UIArtefaktTyp.UEBERSICHT_FONDSANLAGE_ANLAUFMANAGEMENT:
        return AnlaufManagementUebersichtTableComponent;
      case 'Platzhalter':
        return  PlatzhalterComponent;
      default:
        this._errorService.pushErrorMessage(`UIArtefaktTyp '${artefakt.UIArtefakttyp}' ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getBooleanComponent(control: BooleanControl): any {
    switch (control.BooleanComponent) {
      case 'Checkbox':
      case 'PflichtCheckbox':
      case 'CheckboxAusgleichsmanagement':
        return CheckboxComponent;
      case 'JaNeinToggle':
        return JaNeinToggleComponent;
      case 'SlideToggle':
        return SlideToggleComponent;
      case 'Lesebestaetigung':
        return LesebestaetigungComponent;
      case 'Kacheln':
        return KachelnComponent;
      case 'AnlagestrategieZuzahlungTyp':
        return KachelnZuzahlungAnlagestrategieComponent;
      default:
        this._errorService.pushErrorMessage(`BooleanComponent '${control.BooleanComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getButtonComponent(control: ButtonControl) {
    switch (control.ButtonComponent) {
      case 'Process':
        return ProcessButtonComponent;
      case 'Download':
        return DownloadButtonComponent;
      case 'DownloadMitVorschau':
        return DownloadButtonMitVorschauComponent;
      case 'DownloadVerpflichtendMitVorschau':
        return DownloadButtonMitVorschauComponent;
      case 'Navigation':
        return NavigationButtonComponent;
      case 'ModalDialog':
        return ModalDialogButtonComponent;
      case 'ModalDialogOhneButtons':
        return ModalDialogButtonComponent;
      case 'Info':
        return InfoButtonComponent;
      case 'Action':
        return ActionButtonComponent;
      default:
        this._errorService.pushErrorMessage(`ButtonComponent '${control.ButtonComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getWertemengeComponent(control: Wertemenge): any {
    if (!control.WertemengeComponent) {
      return void 0;
    }
    switch (control.WertemengeComponent) {
      case 'Dropdown':
        return DropdownComponent;
      case 'MultiselectList':
        return MultiselectComponent;
      case 'ButtonToggle':
        return ButtonToggleComponent;
      case 'RadioGroup':
        return RadioGroupComponent;
      case 'RadioGroupInline':
        return RadioGroupComponent;
      case 'GemanagtePortfolioloesung':
        return GemanagtePortfolioloesungComponent;
      case 'Kacheln':
        return KachelnComponent;
      case 'Anlagestrategie':
        return AnlagestrategieComponent;
      case 'AutoComplete':
        if (control.MultiJN) {
          return SearchMultiComponent;
        }
        return SearchSimpleComponent;
      default:
        this._errorService.pushErrorMessage(`WertemengeComponent '${control.WertemengeComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getAbsatzComponent(control: AbsatzControl) {
    switch (control.AbsatzComponent) {
      case 'Standard':
        return AbsatzComponent;
      case 'Erweiterungspanel':
        return AbsatzComponent;
      default:
        this._errorService.pushErrorMessage(`AbsatzComponent '${control.AbsatzComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getIntegerComponent(control: NumberControl) {
    switch (control.NumberComponent) {
      case 'Input':
        return IntegerComponent;
      case 'Slider':
        return SliderComponent;
      default:
        this._errorService.pushErrorMessage(`NumberComponent '${control.NumberComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getTextfeldComponent(control: TextControl) {
    switch (control.TextComponent) {
      case 'Textfeld':
        return TextfeldComponent;
      case 'Textarea':
        return TextareaComponent;
      case 'IBAN':
        return IbanComponent;
      case 'EMailAdresse':
        return EmailadresseComponent;
      default:
        this._errorService.pushErrorMessage(`TextComponent '${control.TextComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getUIContainerComponent(control: UIContainerControl) {
    switch (control.UIContainerComponent) {
      case 'SpalteLinks':
        return UiSpalteComponent;
      case 'SpalteRechts':
        return UiSpalteComponent;
      case 'Menu':
        return MenuComponent;
      case 'BeitragBox':
        return BeitragBoxComponent;
      case 'VotumBox':
        return VotumBoxComponent;
      case 'Variantenvergleich':
        return VariantenvergleichComponent;
      default:
        this._errorService.pushErrorMessage(`UIContainerComponent '${control.UIContainerComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getUiVorgangReferenzComponent(control: UiInputControl) {
    switch (control.Quellsystem) {
      case 'KDB':
        return KundensucheComponent;
      default:
        return void 0;
    }
  }

  private _getDateComponent(control: DateControl) {
    switch (control.DatumComponent) {
      case 'Normal':
        return DateToolboxComponent;
      case 'TagFixiert':
        return DateFixedDayComponent;
      default:
        this._errorService.pushErrorMessage(`DatumComponent '${control.DatumComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
            'bitte eine Komponente dafür anlegen.');
        return void 0;
    }
  }

  private _getRisikosuchfragenComponent(control: RisikosuchfrageControl) {
    switch (control.RisikosuchfrageComponent) {
      case 'AutoComplete':
      case 'Dropdown':
        return RisikosuchfrageComponent;
      default:
        return RisikosuchfrageComponent;
        // this._errorService.pushErrorMessage(`RisikosuchfrageComponent '${control.RisikosuchfrageComponent}' im UIArtefakt ${control.Identifikator} ist unbekannt, ` +
        //     'bitte eine Komponente dafür anlegen.');
        // return void 0;
    }
  }

  private _checkNumberOfNestedArtifacts(artefakt: UIArtefakt) {
    if (!!artefakt.UIArtefakt && artefakt.UIArtefakt.length > 1) {
      this._errorService.pushErrorMessage(`UIArtefakt '${artefakt.Identifikator}' enthält ${artefakt.UIArtefakt.length} geschachtelte UIArtefakte. ` +
          'Erlaubt ist nur ein UIArtefakt. Bitte die Beziehungen im Designer überprüfen.');
    }
  }

}
